import { render } from "./ImageDownloader.vue?vue&type=template&id=2ff59233"
import script from "./ImageDownloader.vue?vue&type=script&lang=js"
export * from "./ImageDownloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__